import { Link, useSearchParams } from "react-router-dom";
import { VIDEOS } from "../data/videos.js";
import { LOAI_TRANG, loaiCuaVideo } from "@shared/video.js";
import { docChon, ghiChon, locVaDem } from "@shared/locMuc.js";
import { KhungHaiCot, NhomLoc, OTim, DongDem } from "../components/LocHaiCot.jsx";
import { TheVideo } from "../components/VideoNgan.jsx";
import { normalize } from "../lib/workspace.js";
import { tuKhoaTrang } from "../lib/videoTrang.js";

/**
 * /video: mọi video ngắn của fundraising.vn, lọc hai cột như các trang khác.
 * Mỗi video dẫn về trang đọc kỹ hơn; đó mới là đích của thư viện này.
 */
/** Chữ tìm được của một video: tiêu đề, mô tả, loạt, trang gắn kèm (cả tên tiếng Anh). */
const chuTim = new Map();
function khop(v, q) {
  if (!chuTim.has(v.id)) chuTim.set(v.id, normalize(`${v.tieuDe} ${v.moTa} ${v.loat} ${v.ganVao.map(tuKhoaTrang).join(' ')}`).replace(/[^a-z0-9]+/g, ' '));
  // Mọi từ gõ vào đều phải có, không cần đúng thứ tự: "money pre" vẫn ra pre-money.
  const tu = normalize(q).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  return tu.every((t) => chuTim.get(v.id).includes(t));
}

export default function VideoLibrary() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const loaiChon = docChon(params, "loai");
  const loatChon = docChon(params, "loat");
  const doi = (key) => (ds) => setParams(ghiChon(params, key, ds), { replace: true });
  const cacLoat = [...new Set(VIDEOS.map((v) => v.loat).filter(Boolean))];
  const { ketQua, dem } = locVaDem(
    VIDEOS,
    [
      { key: "loai", giaTri: loaiCuaVideo },
      { key: "loat", giaTri: (v) => (v.loat ? [v.loat] : []) },
    ],
    { loai: loaiChon, loat: loatChon },
    (v) => khop(v, q),
  );
  const dangLoc = Boolean(q || loaiChon.length || loatChon.length);
  const xoaLoc = () => setParams({}, { replace: true });
  const cacLoai = Object.keys(LOAI_TRANG).filter((k) => VIDEOS.some((v) => loaiCuaVideo(v).includes(k)));

  return (
    <div className="vn-trang">
      <header className="vn-dau">
        <p className="eyebrow">Video ngắn</p>
        <h1>Hiểu một khái niệm gọi vốn trong 60 giây</h1>
        <p className="lead">Mỗi video giải thích một thuật ngữ hoặc một việc cần chuẩn bị, rồi dẫn bạn tới bài đọc kỹ hơn và công cụ để làm ngay. Bấm vào video để xem tại đây.</p>
      </header>
      {VIDEOS.length === 0 ? (
        <section className="surface empty-state">
          <p>Video đầu tiên sắp có. Trong lúc chờ, bắt đầu với <Link to="/thuat-ngu">Từ điển gọi vốn</Link>.</p>
        </section>
      ) : (
        <KhungHaiCot
          soDangChon={loaiChon.length + loatChon.length}
          boLoc={<>
            <NhomLoc tieuDe="Gắn với" chon={loaiChon} onDoi={doi("loai")}
              ds={cacLoai.map((k) => ({ v: k, nhan: LOAI_TRANG[k], dem: dem.loai[k] || 0 }))} />
            {cacLoat.length > 0 && <NhomLoc tieuDe="Loạt video" chon={loatChon} onDoi={doi("loat")}
              ds={cacLoat.map((l) => ({ v: l, nhan: l, dem: dem.loat[l] || 0 }))} />}
          </>}
        >
          <OTim id="video-tim" nhan="Tìm video" value={q} placeholder="Tìm: vesting, pre-money, pitch deck…"
            onChange={(v) => setParams(ghiChon(params, "q", v ? [v] : []), { replace: true })} />
          <DongDem dangLoc={dangLoc} onXoa={xoaLoc}>
            Hiển thị <b>{ketQua.length}</b> trên {VIDEOS.length} video.
          </DongDem>
          {ketQua.length > 0 ? (
            <div className="vn-ds">
              {ketQua.map((v) => <TheVideo key={v.id} v={v} tieuDeCap="h2" />)}
            </div>
          ) : (
            <div className="empty-state">
              <p>Chưa có video cho lựa chọn này.</p>
              <button type="button" className="nut phu" onClick={xoaLoc}>Xem tất cả video</button>
            </div>
          )}
        </KhungHaiCot>
      )}
    </div>
  );
}
